export default __webpack_public_path__ + "static/media/down.fe48ae4a.svg";